import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./landingScreen.module.css";

import img1 from "../../assets/intro_screens/Intro_img_1.jpg";
import img2 from "../../assets/intro_screens/Intro_img_2.jpg";
import img3 from "../../assets/intro_screens/Intro_img_3.jpg";
import img4 from "../../assets/intro_screens/Intro_img_4.jpg";
import img5 from "../../assets/intro_screens/Intro_img_5.jpg";
import img6 from "../../assets/intro_screens/Intro_img_6.jpg";
import img7 from "../../assets/intro_screens/Intro_img_7.jpg";

const SLIDES = [
  // {
  //   img: img1,
  //   title: "Earn up to US$ 2,000 per month with VisaLancer!",
  //   description: (
  //     <div>
  //       <div>
  //         It’s the 1<sup>st</sup> Community Commerce Platform for an Industry
  //         with 1.4 billion customers.
  //       </div>
  //       <br />
  //       <div>
  //         This program is open to all and is dynamic, disruptive and discreet.
  //       </div>
  //     </div>
  //   ),
  //   classes: `${styles.slide} ${styles.slide1}`,
  //   titleClass: `${styles.slideTitle} ${styles.slide1Title}`,
  //   descClass: styles.slideDescription,
  //   extraStyle: { color: "white" },
  //   boxClass: styles.slide1_box,
  // },
  // {
  //   img: img2,
  //   caption: "The Product for You!",
  //   title: (
  //     <div>
  //       1<sup>st</sup> Mobile App for Freelancers for Travel Visa
  //     </div>
  //   ),
  //   description: (
  //     <div>
  //       <div>Earn for Life! </div>
  //       <div>Unique Code on Registration.</div>
  //       <div>Code is embedded. </div>
  //       <div>Code is Confidential.</div>
  //       <div>
  //         Our code is <i>Hush Hush</i>!
  //       </div>
  //     </div>
  //   ),
  //   classes: styles.slide,
  //   titleClass: `${styles.slideTitle} ${styles.slide2Title}`,
  //   descClass: styles.slideDescription,
  //   extraStyle: { justifyContent: "flex-end", color: "white" },
  //   boxClass: styles.slide2_box,
  // },
  // {
  //   img: img3,
  //   title: "We crafted a terrific product for your Customers!",
  //   description: `It’s a Biometric Mobile App for e-Visa to 50+ countries and
  //   eTA/ESTA To USA, UK and Canada.`,
  //   classes: `${styles.slide} ${styles.slide3}`,
  //   titleClass: `${styles.slideTitle} ${styles.slide3Title}`,
  //   descClass: `${styles.slide1Description} ${styles.slide3Description}`,
  //   extraStyle: {
  //     // background: "red",
  //     // height: 'min-content',
  //     // background: "#F8C0E3B2",
  //   },
  //   boxClass: styles.slide3_box,
  // },
  {
    img: img4,
    title: "Tired of the Grind?",
    description: (
      <div>Long thankless hours, caged in your career and feel underpaid?</div>
    ),
    classes: `${styles.slide} ${styles.slide3}`,
    titleClass: `${styles.slideTitle} ${styles.slide3Title}`,
    descClass: `${styles.slide1Description} ${styles.slide4Description}`,
    boxClass: styles.slide4_box,
    bgColor: "#FFFFFF"
  },
  // {
  //   img: img5,
  //   title: "What do you have to do?",
  //   description: (
  //     <div>
  //       <div>Share with your Social Network</div>
  //       <div>No Selling</div>
  //       <div>No B.S</div>
  //     </div>
  //   ),
  //   classes: `${styles.slide} ${styles.slide5}`,
  //   titleClass: `${styles.slideTitle} ${styles.slide3Title}`,
  //   descClass: `${styles.slide1Description} ${styles.slide5Description}`,
  //   boxClass: styles.slide5_box,
  //   extraStyle: { color: "white" },
  // },
  {
    img: img6,
    title: <div style={{ color: "white" }}>Simple & Secure!</div>,
    description: (
      <div style={{ color: "#000000B2" }}>
        You get <span style={{ fontWeight: 700 }}>paid</span> even if your
        friends-friends-friends-friend also applies for a Visa.
      </div>
    ),
    classes: `${styles.slide} ${styles.slide5}`,
    titleClass: `${styles.slideTitle} ${styles.slide3Title}`,
    descClass: `${styles.slide1Description} ${styles.slide5Description}`,
    extraStyle: { color: "black", justifyContent: "flex-end" },
    boxClass: styles.slide6_box,
    bgColor: "conic-gradient(from 38.47deg at 50% 50%, #FFB025 -54deg, #FFAF28 7.2deg, #FFBB40 14.4deg, #FEBC44 36deg, #FEB930 136.8deg, #FFB023 234deg, #FEB232 270deg, #F6A315 280.8deg, #F9A81B 291.6deg, #FFB025 306deg, #FFAF28 367.2deg)",
    mainContent: (
      <div style={{ fontSize: 20, fontWeight: 500 }}>
        <div>
          <span>you</span> <b>register</b>{" "}
        </div>

        <div>
          <span>you</span> <b>share</b>
        </div>
        <div>
          <span>we</span> <b>auto-track</b>
        </div>
        <div>
          <span>we</span> <b>auto-pay</b>
        </div>
        <div>
          <span>you</span> <b>auto-spend</b>
        </div>
      </div>
    ),
  },
  {
    img: img7,
    title: "The Visa App is Great and so are the $$$!",
    description: `Wanna upgrade your life?`,
    classes: `${styles.slide} ${styles.slide5}`,
    titleClass: `${styles.slideTitle} ${styles.slide3Title}`,
    descClass: `${styles.slide1Description} ${styles.slide5Description}`,
    extraStyle: { color: "black" },
    boxClass: styles.slide7_box,
    bgColor: "linear-gradient(90deg, #BBDADD 0%, #B7DBE1 67%, #AACBD2 100%)"
  },
];

export default function LandingScreen() {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const isLastSlide = activeIndex === SLIDES.length - 1;

  return (
    <div className={styles.landingContainer}>
      <Carousel
        // autoPlay
        transitionTime={500}
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        showIndicators={false}
        infiniteLoop={false}
        selectedItem={activeIndex}
        onChange={setActiveIndex}
        className="carousel_slider"
      >
        {SLIDES.map(
          (
            {
              img,
              caption,
              title,
              description,
              mainContent,
              classes,
              titleClass,
              descClass,
              boxClass,
              extraStyle,
            },
            idx,
          ) => (
            <div
              key={idx}
              className={classes}
              style={{ backgroundImage: `url(${img})`, ...extraStyle }}
            >
              <div className={`${styles.main_box} ${boxClass}`}>
                {caption && (
                  <div className={styles.captionTitle}>{caption}</div>
                )}
                <div className={titleClass}>{title}</div>
                {mainContent && (
                  <>
                    <br />
                    <div>{mainContent}</div>
                  </>
                )}
                <br />
                <div className={descClass}>{description}</div>
              </div>
              <div className={styles.emptySpace} />
            </div>
          ),
        )}
      </Carousel>

      {/* Indicators + Button */}
      <div className={`${styles.bottomButton} ${styles.bottomOverlay}`}>
        <div className={styles.indicatorContainers}>
          {SLIDES.map((_, idx) => (
            <span
              key={idx}
              className={styles.indicator}
              style={{
                background: activeIndex === idx ? "black" : "white",
                borderColor: activeIndex === idx ? "white" : "black",
              }}
              onClick={() => setActiveIndex(idx)}
            />
          ))}
        </div>
        <button
          onClick={() => navigate("/registration")}
          className={styles.findFreedomBtn}
        >
          Find Your Freedom{" "}
        </button>

        <div>
          Join thousands breaking free
        </div>
      </div>
    </div>
  );
}
